import { arrayWithoutSubset, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SuggestedUsersDismissFulfilledAction } from '../../domains/suggestedUserDismiss/actions.types';
import {
  SuggestedUsersLoadAction,
  SuggestedUsersLoadFulfilledAction,
  SuggestedUsersLoadMoreAction,
  SuggestedUsersLoadMoreFulfilledAction,
} from '../../domains/suggestedUsers/actions.types';

import { ViewerSuggestedUsers } from './types';

export const initialState: ViewerSuggestedUsers = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreSuggestedUserFulfilled = (state: ViewerSuggestedUsers, action: SuggestedUsersLoadMoreFulfilledAction) => {
  if (!state.fulfilled) {
    return setFulfilled({
      suggestedUserIds: action.payload.entities.viewerSuggestedUsers.suggestedUserIds,
      dismissedSuggestedUserIds: [],
    });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedUserIds: [
        ...new Set([
          ...state.fulfilled.suggestedUserIds,
          ...arrayWithoutSubset(
            action.payload.entities.viewerSuggestedUsers.suggestedUserIds,
            state.fulfilled.dismissedSuggestedUserIds
          ),
        ]),
      ],
    },
  };
};

const dismissSuggestedUserFulfilled = (state: ViewerSuggestedUsers, action: SuggestedUsersDismissFulfilledAction) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      suggestedUserIds: state.fulfilled.suggestedUserIds.filter((id) => id !== action.payload.userId),
      dismissedSuggestedUserIds: [...state.fulfilled.dismissedSuggestedUserIds, action.payload.userId],
    },
  };
};
const loadSuggestedUserFulfilled = (state: ViewerSuggestedUsers, action: SuggestedUsersLoadFulfilledAction) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerSuggestedUsers, dismissedSuggestedUserIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedUserIds: arrayWithoutSubset(
        action.payload.entities.viewerSuggestedUsers.suggestedUserIds,
        state.fulfilled.dismissedSuggestedUserIds
      ),
    },
  };
};

export type SuggestedUsersAction =
  | SuggestedUsersLoadAction
  | SuggestedUsersLoadMoreAction
  | SuggestedUsersDismissFulfilledAction;

const reducer: Reducer<ViewerSuggestedUsers, SuggestedUsersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_USERS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_USERS.LOAD_FULFILLED':
      return loadSuggestedUserFulfilled(state, action);
    case 'SUGGESTED_USERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_USERS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedUserFulfilled(state, action);
    case 'SUGGESTED_USERS.DISMISS_FULFILLED':
      return dismissSuggestedUserFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
